import React from "react";
import { AddExistingClientDetailsScreenWithBookingData } from "~/features/book-appointment/AddExistingClientDetailsScreen";

const Component = () => {
  return <AddExistingClientDetailsScreenWithBookingData />;
};

export default Component;
